import React from "react";

export const LegalContent = ({ view, company, steuer }) => {
  const c = company || {};
  const s = steuer || {};
  const name = c.company_name || c.owner_name || "—";
  const vertreter = c.owner_name || "";
  const ustid = s.ustid || "";
  const stnr = s.steuernummer || "";
  if (view === "datenschutz") {
    return (
      <div className="space-y-4 text-sm leading-relaxed" data-testid="legal-datenschutz">
        <h2 className="font-[Playfair_Display] text-2xl font-semibold">Datenschutzerklärung</h2>
        <p>
          Wir freuen uns über Ihr Interesse. Der Schutz Ihrer personenbezogenen Daten
          ist uns ein wichtiges Anliegen. Nachfolgend informieren wir Sie gemäß
          Art. 13 DSGVO über die Verarbeitung Ihrer Daten.
        </p>
        <h3 className="font-semibold">1. Verantwortlicher</h3>
        <p>
          {name}
          {vertreter && <>, vertreten durch {vertreter}</>}
          <br />
          {c.strasse}
          <br />
          {c.plz_ort}
          {c.land ? `, ${c.land}` : ""}
          <br />
          {c.email && <>E-Mail: {c.email}<br /></>}
          {c.telefon && <>Telefon: {c.telefon}</>}
        </p>
        <h3 className="font-semibold">2. Verarbeitung im Rahmen des Angebots</h3>
        <p>
          Zur Erstellung und Übermittlung dieses Angebots/dieser Rechnung verarbeiten wir
          die von Ihnen bzw. im Geschäftsverkehr erhobenen Stammdaten (Name, Anschrift,
          Kontaktdaten) sowie die Angebots-/Rechnungsdaten. Rechtsgrundlage ist
          Art. 6 Abs. 1 lit. b DSGVO (Vertrag/vorvertragliche Maßnahmen) sowie
          Art. 6 Abs. 1 lit. c DSGVO (gesetzliche Aufbewahrungspflichten).
        </p>
        <h3 className="font-semibold">3. Speicherdauer</h3>
        <p>
          Ihre Daten werden gelöscht, sobald sie für die genannten Zwecke nicht mehr
          erforderlich sind, soweit keine gesetzlichen Aufbewahrungsfristen (insb. handels-
          und steuerrechtlich, i. d. R. bis zu 10 Jahre) entgegenstehen.
        </p>
        <h3 className="font-semibold">4. Ihre Rechte</h3>
        <p>
          Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der
          Verarbeitung, Datenübertragbarkeit sowie Widerspruch. Zudem steht Ihnen ein
          Beschwerderecht bei einer Datenschutzaufsichtsbehörde zu. Wenden Sie sich
          hierzu bitte an {c.email || "die oben genannten Kontaktdaten"}.
        </p>
      </div>
    );
  }
  return (
    <div className="space-y-4 text-sm leading-relaxed" data-testid="legal-impressum">
      <h2 className="font-[Playfair_Display] text-2xl font-semibold">Impressum</h2>
      <p className="text-[var(--brand-muted)]">Angaben gemäß § 5 DDG (ehem. § 5 TMG)</p>
      <p>
        <strong>{name}</strong>
        <br />
        {c.strasse}
        <br />
        {c.plz_ort}
        {c.land ? `, ${c.land}` : ""}
      </p>
      {vertreter && (
        <p>
          <span className="text-[var(--brand-muted)]">Vertreten durch: </span>
          {vertreter}
        </p>
      )}
      <h3 className="font-semibold">Kontakt</h3>
      <p>
        {c.telefon && <>Telefon: {c.telefon}<br /></>}
        {c.email && <>E-Mail: {c.email}<br /></>}
        {c.website && <>Web: {c.website}</>}
      </p>
      {(ustid || stnr) && (
        <>
          <h3 className="font-semibold">Umsatzsteuer / Steuer</h3>
          <p>
            {ustid && <>USt-IdNr. gemäß § 27a UStG: {ustid}<br /></>}
            {stnr && <>Steuernummer: {stnr}</>}
          </p>
        </>
      )}
      <p className="text-xs text-[var(--brand-muted)]">
        Verantwortlich für den Inhalt: {vertreter || name}.
      </p>
    </div>
  );
};
